import * as Yup from "yup";
import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { stringValidation } from "../providers/validations";
import Field from "../components/Field";
import { FileUpload, Select, Text } from "../inputs";
import { Form } from "../template";
import { SHA256 } from "crypto-js";
import { mainApi } from "../providers/api";
import objectPath from "object-path";
export const classificationType = [
  {
    // label: `Тэмдэг`,
    label: `象征`,
    value: `sign`,
  },
  {
    // label: `Самбар`,
    label: `木板`,
    value: `poster`,
  },
  {
    label: `产品`,
    // label: `Бүтээгдэхүүн`,
    value: `product`,
  },
];
const UserForm = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const props = {
    editable: true,
    isDeletable: true,
    model: "type",
    text: id ? "Төрлийн мэдээлэл" : "Төрөл бүртгэх",
    id: id,
    init: {},
    validationSchema: Yup.object().shape({
      type: stringValidation(true),
      classification: stringValidation(true),
    }),
  };
  const beforeSubmit = async (data) => {
    return data;
  };
  return (
    <Form {...props} beforeSubmit={beforeSubmit}>
      {({ submited, disabled, values }) => {
        return (
          <div className="p-5 bg-white  grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="flex flex-col gap-4">
              <Field
                name="classification"
                label={t("type.type")}
                disabled={disabled}
                component={Select}
                items={classificationType}
                type="text"
              />
            </div>
            <div className="flex flex-col gap-4">
              <Field
                name="type"
                label={t("type.name")}
                disabled={disabled}
                component={Text}
                type="text"
                className={`text-black `}
              />
            </div>
          </div>
        );
      }}
    </Form>
  );
};

export default UserForm;
